<template>
  <v-form @submit.prevent="handleSubmit" class="customer-form">
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="form.name"
          label="Name"
          required
          variant="outlined"
          density="comfortable"
          :rules="[v => !!v || 'Name is required']"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="form.lastName"
          label="Last Name"
          required
          variant="outlined"
          density="comfortable"
          :rules="[v => !!v || 'Last name is required']"
        />
      </v-col>
    </v-row>
    <v-text-field
      v-model="form.email"
      label="Email"
      type="email"
      required
      variant="outlined"
      density="comfortable"
      class="mb-1"
      :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'Email must be valid']"
    />
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="form.phone"
          label="Phone"
          variant="outlined"
          density="comfortable"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="form.city"
          label="City"
          variant="outlined"
          density="comfortable"
        />
      </v-col>
    </v-row>
    <div class="form-actions mt-4">
      <v-spacer></v-spacer>
      <v-btn variant="text" @click="$emit('cancel')">Cancel</v-btn>
      <v-btn color="primary" variant="flat" type="submit">{{ mode === 'edit' ? 'Update' : 'Create' }}</v-btn>
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'CustomerForm',
  props: {
    customer: { type: Object, default: null },
    mode: { type: String, default: 'create' },
  },
  data() {
    return {
      form: {
        name: this.customer?.name || '',
        lastName: this.customer?.lastName || '',
        email: this.customer?.email || '',
        phone: this.customer?.phone || '',
        city: this.customer?.city || '',
      },
    };
  },
  watch: {
    customer: {
      handler(newVal) {
        this.form = {
          name: newVal?.name || '',
          lastName: newVal?.lastName || '',
          email: newVal?.email || '',
          phone: newVal?.phone || '',
          city: newVal?.city || '',
        };
      },
      immediate: true,
    },
  },
  methods: {
    handleSubmit() {
      if (!this.form.name || !this.form.lastName || !this.form.email) {
        alert('Name, Last Name, and Email are required.');
        return;
      }
      this.$emit('submit', { ...this.form });
    },
  },
};
</script>

<style scoped>
.form-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
</style> 